import { FormattedMessage } from 'react-intl';
import Button from '@mui/material/Button';
import { useNavigate, useQuery } from '../../routes';
import { plan } from '../../layout/routes';

export const ExploreProducts = () => {
  const { navigate, replaceQuery } = useNavigate();
  const { queryDictionary } = useQuery();

  const explorePlan = () => {
    navigate(
      plan.path,
      replaceQuery(queryDictionary()),
    );
  };

  return (
    <Button
      variant="contained"
      size="small"
      onClick={explorePlan}
      sx={theme => ({
        color: '#FFFFFF',
        backgroundColor: '#5959EB',
        '&:hover': {
          backgroundColor: '#43509B',
        },
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      })}
    >
      <FormattedMessage id="page.subscription.empty.subscription.explore.btn" />
    </Button>
  );
};
